﻿import "bootstrap/js/src/modal";
import $ from "jquery";

const gallery = $('#image-gallery');

if (gallery) {

    let thumbs = [...document.querySelectorAll('#article-image, .gallery-thumbnail')];

    thumbs.forEach((element, index) => {
        element.addEventListener('click', () => {
            gallery.carousel(index);
        })
    });

}
